import { create } from 'zustand';
/**
 * 앱 내 전역적으로 포커스 된 띠를 관리합니다.
 * @param set
 */
var focusedBand = create(function (set) { return ({
    setFocusedBand: function (tvingBand) {
        set(function () { return ({
            focusedBand: tvingBand,
        }); });
    },
}); });
export var useFocusedBandStore = focusedBand;
